<template>
  <v-container :key="clinicUp" fluid style="padding:0" v-if="showWorksheet" >
    <v-form :disabled="readonly" ref="clinicform" v-model="mdmValidInt">
        <v-row no-gutters class="pb-0" style="height:50px;">
            <v-col :cols="(addCC ? 5 : 6)">
                <v-select
                    class="demofields tallField"
                    dense
                    outlined
                    v-model="mdmVal.worksheet.general.patientType"
                    :items="patientTypes"
                    :label="(qaEnc && mdmQaVal && mdmQaVal.worksheet.general.patientType ? 'Patient/Visit Type: ' + mdmQaVal.worksheet.general.patientType + (mdmQaVal.worksheet.general.patientType == mdmVal.worksheet.general.patientType ? ' - ✓' : ' - ✗' ) : 'Patient/Visit Type')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    @input="calculateCLINIC"
                ></v-select>
            </v-col>
            <v-col :cols="(addCC ? 2 : 3)">
                <v-text-field
                    class="demofields tallField"
                    dense
                    outlined
                    v-model="mdmVal.worksheet.time"
                    type="number"
                    step="5"
                    min="0"
                    :label="(qaEnc && mdmQaVal && mdmQaVal.worksheet.time ? 'Time: ' + mdmQaVal.worksheet.time + (mdmQaVal.worksheet.time == mdmVal.worksheet.time ? ' - ✓' : ' - ✗' ) : 'Time')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    @input="calculateCLINIC"
                    :disabled="mdmVal.worksheet.nurse_only || this.pos == '23'"
                ></v-text-field>
            </v-col>
            <v-col :cols="(addCC ? 2 : 3)">
                <v-text-field
                    class="demofields tallField"
                    dense
                    outlined
                    v-model="mdmVal.worksheet.cc_time"
                    type="number"
                    step="5"
                    min="0"
                    :label="(qaEnc && mdmQaVal && mdmQaVal.worksheet.cc_time ? 'CC Time: ' + mdmQaVal.worksheet.cc_time + (mdmQaVal.worksheet.cc_time == mdmVal.worksheet.cc_time ? ' - ✓' : ' - ✗' ) : 'CC Time')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    @input="calculateCLINIC"
                    :disabled="!showCCTime"
                ></v-text-field>
            </v-col>
            <v-col v-if="addCC" class="text-center">
                <v-checkbox @change="calculateCLINIC" 
                    style="height: 20px; padding-left: 8px; margin-top: 8px;"
                    :label="(qaEnc && mdmQaVal && mdmQaVal.worksheet.cc_add ? 'Add CC EM: ' + mdmQaVal.worksheet.cc_add + (mdmQaVal.worksheet.cc_add == mdmVal.worksheet.cc_add ? ' - ✓' : ' - ✗' ) : 'Additional CC EM')"
                    v-model="mdmVal.worksheet.cc_add"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row no-gutters class="pb-2" style="height:60px;">
            <v-col :cols="nurseOnly ? 5: 6">
                <v-autocomplete
                    class="demofields tallField"
                    dense
                    :label="(qaEnc && mdmQaVal.em[0] ? 'BP: ' + getProviderDetail(mdmQaVal.em[0].billing_provider) + (mdmQaVal.em[0].billing_provider == mdmVal.em[0].billing_provider ? ' - ✓' : ' - ✗' ) : 'Billing Provider')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    :rules="fieldRuleDep(mdmVal.em[0].billing_provider,'billing_provider',mdmVal.em[0].code)"
                    v-model="mdmVal.em[0].billing_provider"
                    outlined
                    item-text="displayName"
                    item-value="clientid"
                    :items=$store.getters.Providers
                ></v-autocomplete>
            </v-col>
            <v-col :cols="nurseOnly ? 5: 6">
                <v-autocomplete
                    class="demofields tallField"
                    dense
                    :label="(qaEnc && mdmQaVal.em[0] ? 'SP: ' + getProviderDetail(mdmQaVal.em[0].secondary_provider) + (mdmQaVal.em[0].secondary_provider == mdmVal.em[0].secondary_provider ? ' - ✓' : ' - ✗' ) : 'Secondary Provider')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    :rules="fieldRuleDep(mdmVal.em[0].secondary_provider,'secondary_provider',mdmVal.em[0].code)"
                    v-model="mdmVal.em[0].secondary_provider"
                    outlined
                    item-text="displayName"
                    item-value="clientid"
                    :items=$store.getters.Providers
                ></v-autocomplete>
            </v-col>
            <v-col v-if="nurseOnly" class="text-center">
                <v-checkbox @change="calculateCLINIC" 
                    style="height: 20px; padding-left: 8px; margin-top: 8px;"
                    :label="(qaEnc && mdmQaVal && mdmQaVal.worksheet.nurse_only ? 'Nurse Only visit: ' + mdmQaVal.worksheet.nurse_only + (mdmQaVal.worksheet.nurse_only == mdmVal.worksheet.nurse_only ? ' - ✓' : ' - ✗' ) : 'Nurse Only Visit')"
                    v-model="mdmVal.worksheet.nurse_only"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row v-if="!mdmVal.worksheet.nurse_only">
            <v-expansion-panels 
                :style="'border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                :dark="proMode" 
                v-model="proworksheetexp" 
                multiple 
                accordion
                tile
            >
                <v-expansion-panel
                    key="charta"
                >
                    <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                        Chart A {{(clinicTool.charta ? " - " + clinicTool.charta : "")}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2 mx-0 py-2">
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Number/Complexity of Problem Addressed-Nature of Presenting Problem (Chart A)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Risk
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        {{(qaEnc ? 'QA' : 'Number/Complexity')}}
                                    </v-col>
                                    <v-col cols="5" v-if="qaEnc" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Original
                                    </v-col>
                                    
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">Straightforward</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.straightforward.self_limited_minor_1"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Self-Limited/Minor Problem
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.self_limited_minor">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon
                                                                color="primary"
                                                                :dark="proMode"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                mdi-information-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>{{worksheetsettings.labels.charta.self_limited_minor}}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.charta.straightforward,mdmQaVal.worksheet.charta.straightforward) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Self-Limited/Minor Problem"
                                            readonly
                                            v-model="mdmQaVal.worksheet.charta.straightforward.self_limited_minor_1"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">Low</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.low.self_limited_minor_2"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    2+ Self-Limited/Minor Problem
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.self_limited_minor">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.self_limited_minor}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.low.stable_chronic_1"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Stable Chronic Illness
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.stable_chronic">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.stable_chronic}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.low.stable_acute_1"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Stable Acute Illness
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.stable_acute">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.stable_acute}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.low.acute_uncomplicated_1"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Acute Uncomplicated Illness/Injury
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.acute_uncomplicated">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.acute_uncomplicated}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 60px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.low.acute_uncomplicated_hospital_1"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Acute Uncomplicated Illness/Injury requiring hospital inpatient or observation care
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.acute_uncomplicated_hospital">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.acute_uncomplicated_hospital}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.charta.low,mdmQaVal.worksheet.charta.low) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="2+ Self-Limited/Minor Problem"
                                            v-model="mdmQaVal.worksheet.charta.low.self_limited_minor_2"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Stable Chronic Illness"
                                            v-model="mdmQaVal.worksheet.charta.low.stable_chronic_1"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Stable Acute Illness"
                                            v-model="mdmQaVal.worksheet.charta.low.stable_acute_1"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Acute Uncomplicated Illness/Injury"
                                            v-model="mdmQaVal.worksheet.charta.low.acute_uncomplicated_1"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 60px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Acute Uncomplicated Illness/Injury requiring hospital inpatient or observation care"
                                            v-model="mdmQaVal.worksheet.charta.low.acute_uncomplicated_hospital_1"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">Moderate</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.moderate.chronic_illness_ex_1"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1+ Chronic Illness w/ exacerbation, progression or Tx side effects
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.chronic_illness_ex">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.chronic_illness_ex}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.moderate.stable_chronic_2"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    2+ Stable Chronic Illness
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.self_limited_minor">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.self_limited_minor}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.moderate.undiagnosed_problem_uncertain"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Undiagnosed problem w/ uncertain prognosis
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.undiagnosed_problem_uncertain">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.undiagnosed_problem_uncertain}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.moderate.acute_illness_systemic"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Acute Illness w/ Systemic Symptoms
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.acute_illness_systemic">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.acute_illness_systemic}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.moderate.acute_complicated_injury"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Acute Complicated Injury
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.acute_complicated_injury">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.acute_complicated_injury}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.charta.moderate,mdmQaVal.worksheet.charta.moderate) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="1+ Chronic Illness w/ exacerbation, progression or Tx side effects"
                                            v-model="mdmQaVal.worksheet.charta.moderate.chronic_illness_ex_1"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="2+ Stable Chronic Illness"
                                            v-model="mdmQaVal.worksheet.charta.moderate.stable_chronic_2"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Undiagnosed problem w/ uncertain prognosis"
                                            v-model="mdmQaVal.worksheet.charta.moderate.undiagnosed_problem_uncertain"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Acute Illness w/ Systemic Symptoms"
                                            v-model="mdmQaVal.worksheet.charta.moderate.acute_illness_systemic"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Acute Complicated Injury"
                                            v-model="mdmQaVal.worksheet.charta.moderate.acute_complicated_injury"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">High</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.high.chronic_illness_severe_ex"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1+ Chronic Illness w/ Severe exacerbation, progression of Tx side effects
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.chronic_illness_severe_ex">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.chronic_illness_severe_ex}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 60px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.charta.high.acute_chronic_illness_injury_threat_to_life"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    1 Acute/Chronic Illness/Injury that pose threat to life or bodily function
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.charta.acute_chronic_illness_injury_threat_to_life">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.charta.acute_chronic_illness_injury_threat_to_life}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.charta.high,mdmQaVal.worksheet.charta.high) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="1+ Chronic Illness w/ Severe exacerbation, progression of Tx side effects"
                                            v-model="mdmQaVal.worksheet.charta.high.chronic_illness_severe_ex"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC"
                                        readonly 
                                            style="height: 60px; padding-left: 8px; margin-top: 8px;"
                                            label="1 Acute/Chronic Illness/Injury that pose threat to life or bodily function"
                                            v-model="mdmQaVal.worksheet.charta.high.acute_chronic_illness_injury_threat_to_life"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                    key="chartb"
                >
                    <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                        Chart B {{(clinicTool.chartb ? " - " + clinicTool.chartb : "")}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2 mx-0 py-2">
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Review and Analyzed Data
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        {{(qaEnc ? 'QA' : '')}}
                                    </v-col>
                                    <v-col cols="2" v-if="qaEnc" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Original
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)"  @click="(!readonly ? mdmVal.worksheet.chartb.td.review_of_prior_ext_notes = !mdmVal.worksheet.chartb.td.review_of_prior_ext_notes : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Review of prior external note(s) from each unique source*
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.test_unique">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.test_unique}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-text-field
                                            class="demofields tallField"
                                            dense
                                            outlined
                                            v-model="mdmVal.worksheet.chartb.td.review_of_prior_ext_notes"
                                            type="number"
                                            step="1"
                                            min="0"
                                            @input="calculateCLINIC"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartb.td.review_of_prior_ext_notes != mdmQaVal.worksheet.chartb.td.review_of_prior_ext_notes ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-text-field
                                        readonly
                                            class="demofields tallField"
                                            dense
                                            outlined
                                            v-model="mdmQaVal.worksheet.chartb.td.review_of_prior_ext_notes"
                                            type="number"
                                            step="1"
                                            min="0"
                                            @input="calculateCLINIC"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartb.td.review_results_of_each_test = !mdmVal.worksheet.chartb.td.review_results_of_each_test : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Review of the result(s) of each unique test*
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.test_unique">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.test_unique}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-text-field
                                            class="demofields tallField"
                                            dense
                                            outlined
                                            v-model="mdmVal.worksheet.chartb.td.review_results_of_each_test"
                                            type="number"
                                            step="1"
                                            min="0"
                                            @input="calculateCLINIC"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartb.td.review_results_of_each_test != mdmQaVal.worksheet.chartb.td.review_results_of_each_test ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-text-field
                                        readonly
                                            class="demofields tallField"
                                            dense
                                            outlined
                                            v-model="mdmQaVal.worksheet.chartb.td.review_results_of_each_test"
                                            type="number"
                                            step="1"
                                            min="0"
                                            @input="calculateCLINIC"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartb.td.ordering_of_each_test = !mdmVal.worksheet.chartb.td.ordering_of_each_test : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Ordering of each unique test*
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.test_unique">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.test_unique}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-text-field
                                            class="demofields tallField"
                                            dense
                                            outlined
                                            v-model="mdmVal.worksheet.chartb.td.ordering_of_each_test"
                                            type="number"
                                            step="1"
                                            min="0"
                                            @input="calculateCLINIC"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartb.td.ordering_of_each_test != mdmQaVal.worksheet.chartb.td.ordering_of_each_test ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-text-field
                                        readonly
                                            class="demofields tallField"
                                            dense
                                            outlined
                                            v-model="mdmQaVal.worksheet.chartb.td.ordering_of_each_test"
                                            type="number"
                                            step="1"
                                            min="0"
                                            @input="calculateCLINIC"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
                            <v-col cols="12">
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartb.ihx.individual_who_provides_history = !mdmVal.worksheet.chartb.ihx.individual_who_provides_history : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Straightforward or None
                                        <!--<v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.min_none">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.min_none}}</span>
                                        </v-tooltip>-->
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartb.min_none"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartb.min_none != mdmQaVal.worksheet.chartb.min_none ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartb.min_none"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartb.ihx.individual_who_provides_history = !mdmVal.worksheet.chartb.ihx.individual_who_provides_history : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Independant historian(s) (eg, parent, guardian, surrogate, spouses, witness, EMS)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.ind_hist">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.ind_hist}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartb.ihx.individual_who_provides_history"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartb.ihx.individual_who_provides_history != mdmQaVal.worksheet.chartb.ihx.individual_who_provides_history ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartb.ihx.individual_who_provides_history"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
                            <v-col cols="12">
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartb.intpr.independent_interpretation_of_a_test = !mdmVal.worksheet.chartb.intpr.independent_interpretation_of_a_test : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Independent interpretation of a test performed by another physician/other qualified health care professionals (not separately reported):
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.ind_int">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.ind_int}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartb.intpr.independent_interpretation_of_a_test"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartb.intpr.independent_interpretation_of_a_test != mdmQaVal.worksheet.chartb.intpr.independent_interpretation_of_a_test ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartb.intpr.independent_interpretation_of_a_test"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int = !mdmVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Discussion of management or test interpretion with external physician/other qualified health care professional/appropriate source (not separately reported)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartb.ext_disc">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartb.ext_disc}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int != mdmQaVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                    key="chartc"
                >
                    <v-expansion-panel-header class="py-0" :color = "(proMode ? 'rgba(255, 255, 255, 0.08)':'rgba(0, 0, 0, 0.08)')" :style="'border-bottom:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')">
                        Chart C {{(clinicTool.chartc ? " - " + clinicTool.chartc : "")}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2 mx-0 py-2">
                        <v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Risk of complications and/or Morbidity or Morality of Patient Management (Chart C)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.risk_morbidity">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.risk_morbidity}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Level
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        {{(qaEnc ? 'QA' : 'Risk of Complications')}}
                                    </v-col>
                                    <v-col cols="5" v-if="qaEnc" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Original
                                    </v-col>
                                    
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">Straightforward</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.straightforward.risk_of_morbidity"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Minimal risk of morbidity from additional diagnostic testing or treatment
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.risk_morbidity">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.risk_morbidity}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Rest"
                                            v-model="mdmVal.worksheet.chartc.straightforward.rest"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Gargles"
                                            v-model="mdmVal.worksheet.chartc.straightforward.gargles"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Elastic bandages"
                                            v-model="mdmVal.worksheet.chartc.straightforward.elastic_bandages"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Superficial dressing"
                                            v-model="mdmVal.worksheet.chartc.straightforward.superficial_dressing"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.chartc.straightforward,mdmQaVal.worksheet.chartc.straightforward) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Straightforward risk of morbidity from additional diagnostic testing or treatment"
                                            readonly
                                            v-model="mdmQaVal.worksheet.chartc.straightforward.risk_of_morbidity"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Rest"
                                            readonly
                                            v-model="mdmQaVal.worksheet.chartc.straightforward.rest"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Gargles"
                                            v-model="mdmQaVal.worksheet.chartc.straightforward.gargles"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Elastic bandages"
                                            v-model="mdmQaVal.worksheet.chartc.straightforward.elastic_bandages"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Superficial dressing"
                                            v-model="mdmQaVal.worksheet.chartc.straightforward.superficial_dressing"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">Low</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.low.risk_of_morbidity"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Low risk of morbidity from additional diagnostic testing or Treatment
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.risk_morbidity">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.risk_morbidity}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.low.minor_surgery"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Minor surgery with no identified risk factors
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.surgery">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.surgery}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Physical therapy"
                                            v-model="mdmVal.worksheet.chartc.low.physical_therapy"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Occupational therapy"
                                            v-model="mdmVal.worksheet.chartc.low.occupational_therapy"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="IV fluids without additives"
                                            v-model="mdmVal.worksheet.chartc.low.iv_fluids"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.chartc.low,mdmQaVal.worksheet.chartc.low) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Low risk of morbidity from additional diagnostic testing or Treatment"
                                            v-model="mdmQaVal.worksheet.chartc.low.risk_of_morbidity"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Minor surgery with no identified risk factors"
                                            v-model="mdmQaVal.worksheet.chartc.low.minor_surgery"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Physical therapy"
                                            v-model="mdmQaVal.worksheet.chartc.low.physical_therapy"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Occupational therapy"
                                            v-model="mdmQaVal.worksheet.chartc.low.occupational_therapy"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="IV fluids without additives"
                                            v-model="mdmQaVal.worksheet.chartc.low.iv_fluids"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">Moderate</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.moderate.risk_of_morbidity"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Moderate risk of morbidity from additional diagnostic testing or treatment
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.risk_morbidity">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.risk_morbidity}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Prescription drug management"
                                            v-model="mdmVal.worksheet.chartc.moderate.prescription_drug_management"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.moderate.decision_minor_surgery"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Decision regarding minor surgery with identified patient or procedure risk factors
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.surgery">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.surgery}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.moderate.decision_major_surgery"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Decision regarding elective major surgery without identified patient or procedure risk factors
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.surgery">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.surgery}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 60px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.moderate.diagnosis_limited_social"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Diagnosis or treatment significantly limited by social determinants of health
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.soc_det">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.soc_det}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.chartc.moderate,mdmQaVal.worksheet.chartc.moderate) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Moderate risk of morbidity from additional diagnostic testing or treatment"
                                            v-model="mdmQaVal.worksheet.chartc.moderate.risk_of_morbidity"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; padding-left: 8px; margin-top: 8px;"
                                            label="Prescription drug management"
                                            v-model="mdmQaVal.worksheet.chartc.moderate.prescription_drug_management"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision regarding minor surgery with identified patient or procedure risk factors"
                                            v-model="mdmQaVal.worksheet.chartc.moderate.decision_minor_surgery"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision regarding elective major surgery without identified patient or procedure risk factors"
                                            v-model="mdmQaVal.worksheet.chartc.moderate.decision_major_surgery"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 60px; padding-left: 8px; margin-top: 8px;"
                                            label="Diagnosis or treatment significantly limited by social determinants of health"
                                            v-model="mdmQaVal.worksheet.chartc.moderate.diagnosis_limited_social"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="2" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <p class="py-0 my-1">High</p>
                                    </v-col>
                                    <v-col :cols="(qaEnc ? 5 : 10)" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label=""
                                            v-model="mdmVal.worksheet.chartc.high.risk_of_morbidity"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    High risk of morbidity from additional diagnostic testing or treatment
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.risk_morbidity">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon
                                                                color="primary"
                                                                :dark="proMode"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                mdi-information-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>{{worksheetsettings.labels.chartc.risk_morbidity}}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.high.drug_therapy_elective"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Drug therapy requiring intensive monitoring for toxicity
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.drug_therapy">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.drug_therapy}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.high.decision_elective_major"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Decision regarding elective major surgery with identified patient or procedure risk factor
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.surgery">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.surgery}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.high.decision_emergency_surgery"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    Decision regarding emergency major surgery
                                                    <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.surgery">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.surgery}}</span>
                                        </v-tooltip>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision regarding hospitalization or escelation of hospital level care"
                                            v-model="mdmVal.worksheet.chartc.high.decision_hospitilalization"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision not to resuscitate or to deescalate care because of poor prognosis"
                                            v-model="mdmVal.worksheet.chartc.high.decision_dnr"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Parenteral controlled substances"
                                            v-model="mdmVal.worksheet.chartc.high.controlled_substances"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="5" :class="'text-center ' + (compObjs(mdmVal.worksheet.chartc.high,mdmQaVal.worksheet.chartc.high) ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="High risk of morbidity from additional diagnostic testing or treatment"
                                            v-model="mdmQaVal.worksheet.chartc.high.risk_of_morbidity"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Drug therapy regarding elective major surgery with identified patient or procedure risk factor"
                                            v-model="mdmQaVal.worksheet.chartc.high.drug_therapy_elective"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision regarding elective major surgery with identified patient or procedure risk factor"
                                            v-model="mdmQaVal.worksheet.chartc.high.decision_elective_major"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision regarding emergency major surgery"
                                            v-model="mdmQaVal.worksheet.chartc.high.decision_emergency_surgery"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision regarding hospitalization or escelation of hospital level care"
                                            v-model="mdmQaVal.worksheet.chartc.high.decision_hospitilalization"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Decision not to resuscitate or to deescalate care because of poor prognosis"
                                            v-model="mdmQaVal.worksheet.chartc.high.decision_dnr"
                                        ></v-checkbox>
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 40px; padding-left: 8px; margin-top: 8px;"
                                            label="Parenteral controlled substances"
                                            v-model="mdmQaVal.worksheet.chartc.high.controlled_substances"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <!--<v-row no-gutters class="pb-2">
                            <v-col cols="12">
                                <v-row no-gutters class="pb-0">
                                    <v-col cols="12" :class="'text-center text-h6 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Risk of complications and/or Morbidity or Morality of Patient Management (Chart C)
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.header">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.header}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Risk of Complications
                                    </v-col>
                                    <v-col cols="2" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        {{(qaEnc ? 'QA' : 'Level')}}
                                    </v-col>
                                    <v-col cols="2" v-if="qaEnc" :class="'text-subtitle-2 text-center pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        Original
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartc.straightforward = !mdmVal.worksheet.chartc.straightforward : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Straightforward risk of morbidity from additional diagnostic testing or Treatment
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.straightforward">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.straightforward}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.straightforward"
                                            label="Straightforward"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartc.straightforward != mdmQaVal.worksheet.chartc.straightforward ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartc.straightforward"
                                            label="Straightforward"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartc.low = !mdmVal.worksheet.chartc.low : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Low risk of morbidity from additional diagnostic testing or Treatement
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.low">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.low}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.low"
                                            label="Low"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartc.low != mdmQaVal.worksheet.chartc.low ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartc.low"
                                            label="Low"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartc.moderate = !mdmVal.worksheet.chartc.moderate : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        Moderate risk of morbidity from additional diagnostic testing or Treatment
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.moderate">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.moderate}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.moderate"
                                            label="Moderate"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartc.moderate != mdmQaVal.worksheet.chartc.moderate ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartc.moderate"
                                            label="Moderate"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col :cols="(qaEnc ? 8 : 10)" @click="(!readonly ? mdmVal.worksheet.chartc.high = !mdmVal.worksheet.chartc.high : '')" :class="'text-subtitle-1 pa-2 ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')" :style="(readonly ? '' : 'cursor:pointer')">
                                        High risk of morbidity from additional diagnostic testing or Treatment
                                        <v-tooltip max-width="350px" bottom v-if="worksheetsettings.labels && worksheetsettings.labels.chartc.high">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    color="primary"
                                                    :dark="proMode"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>{{worksheetsettings.labels.chartc.high}}</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmVal.worksheet.chartc.high"
                                            label="High"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col v-if="qaEnc" cols="2" :class="'text-center ' + (mdmVal.worksheet.chartc.high != mdmQaVal.worksheet.chartc.high ? 'red ' : '') + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                                        <v-checkbox @change="calculateCLINIC" 
                                        readonly
                                            style="height: 20px; margin-top: 8px;"
                                            v-model="mdmQaVal.worksheet.chartc.high"
                                            label="High"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>-->
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        <v-row class="px-0">
            <v-btn 
                :color="proMode ?  'grey darken-1' : 'grey-darken-4'"
                :background-color = "(proMode ? 'rgba(255, 255, 255, 0.06)':'rgba(0, 0, 0, 0.06)')" 
                icon
                block
                outlined
                style="max-width:100%;border-radius:0;height:20px"
                @click="sectionsExpand = !sectionsExpand"
            >
                <v-icon v-if="sectionsExpand">mdi-chevron-double-up</v-icon>
                <v-icon v-else>mdi-chevron-double-down</v-icon>
            </v-btn>
        </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { ulid } from 'ulid';

export default{
  name: 'CLINICWKSHT',
    props: {
        mdmVal:{
            type:Object,
            required:true
        },
        mdmQaVal:{
            type:Object,
            required:false
        },
        clinicTool:{
            type:Object,
            required:false
        },
        mdmValid:{
            type:Boolean,
            required:false
        },
        qaEnc:{
            type:Boolean,
            required:false
        },
        readonly:{
            type:Boolean,
            required:false
        },
        patientTypes:{
            type:Array,
            required:true
        },
        pos:{
            type:String,
            required:false
        },
        payerType:{
            type:String,
            required:false
        }
    },
    components: { 
        // RXAPI 
    },
    data() {
        return {
            clinicUp:0,
            showWorksheet:false,
            isLoading:false,
            mdmValidInt:false,
            mdmSection:[0],
            worksheetsettings: {},

            checkedboxes:{},

            codetabpro:{},
            sectionsExpand:false,

            checklistSection:[0],
            csectionsExpand:false,

            proworksheetexp:[],

            descriptionLimit: 50,
            entries: [],
            isLoading: false,
            model: null,
            searchAPI:null,

            menu1:[false],
            restab:"",
            difRes: false,

            nurseOnly: false,

            sections:["Chart A","Chart B","Chart C"],

            fieldRule: function(v,f){
                let out = true;
                // if(this.reqCheck(f) && !v){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
            fieldRuleDep: function(v,f,df){
                let out = true;
                if(df && this.reqCheck(f) && !v){
                    //out = 'Field Required to QA/Complete';
                    out='';
                }else{
                }
                return [out];
            },
            fieldRuleInd: function(v,f,ind){
                // let fArr = f.split("_"),
                //     fComb = fArr[0] + "_" + ind + "_" + fArr[1];
                let out = true;
                // if(this.reqCheck(fComb) && !v.code){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
        };
    },
    computed:{
        ...mapGetters(["facility","facSettings","noCalc","proMode","emToolProLT23","calcLogic23","departments"]),
        items () {
            return this.entries.map(entry => {
            const Description = entry.code + " - " + (entry.name.length > this.descriptionLimit
                ? entry.name.slice(0, this.descriptionLimit) + '...'
                : entry.name)

            return Object.assign({}, entry, { Description })
            })
        },
        showCCTime(){
            let out = false;
            if(this.pos && this.calcLogic23[this.pos]){
                if(this.pos == "23" || Object.keys(this.calcLogic23[this.pos]).includes("Critical Care")){
                    out = true;
                }
            }
            return out;
        },
        addCC(){
            let out = false;
            if(this.mdmVal.worksheet.cc_time>29){
                out = true;
            }else{
                this.mdmVal.worksheet.cc_add = false;
            }
            return out;
        }
    },
    watch:{
    //   mdmVal:{
    //       handler: function(enc){
    //         //// console.log("AE CHANGE");
    //         this.mdmChanged();
    //         this.clinicUp++;
    //       },
    //       deep:true
    //   },
      mdmValidInt(val){
          this.$emit('validChanged', val);
      },
      pos(val){
        this.calculateCLINIC();
      },
      sectionsExpand(exp){
          if(exp){
              // console.log("EXPAND!")
              let secsout = [];
              for(let d=0; d<this.sections.length; d++){
                  secsout.push(d);
              }
              // console.log(JSON.stringify(secsout));
              this.proworksheetexp = secsout;
          }else{
              // console.log("UNEXPAND")
              this.proworksheetexp = [];
          }
      },
    },
    mounted: function(){
        if(!this.mdmVal.worksheet || !this.mdmVal.worksheet.charta || !this.mdmVal.worksheet.charta.straightforward){
            this.mdmVal.worksheet = {
                "general": {
                    "patientType": "New"
                },
                "charta": {
                    "straightforward":{
                        "self_limited_minor_1":false
                    },
                    "low":{
                        "self_limited_minor_2":false,
                        "stable_chronic_1":false,
                        "acute_uncomplicated_1":false
                    },
                    "moderate":{
                        "chronic_illness_ex_1":false,
                        "stable_chronic_2":false,
                        "undiagnosed_problem_uncertain":false,
                        "acute_illness_systemic":false,
                        "acute_complicated_injury":false
                    },
                    "high":{
                        "chronic_illness_severe_ex":false,
                        "acute_chronic_illness_injury_threat_to_life":false
                    }
                },
                "chartb": {
                    "td":{
                        "review_of_prior_ext_notes":0,
                        "review_results_of_each_test":0,
                        "ordering_of_each_test":0
                    },
                    "ihx":{
                        "individual_who_provides_history":false
                    },
                    "intpr":{
                        "independent_interpretation_of_a_test":false
                    },
                    "disc":{
                        "discussion_of_mgmt_testing_int":false
                    },
                },
                "chartc": {
                    "straightforward": {
                        "risk_of_morbidity":false,
                        "rest":false,
                        "gargles":false,
                        "elastic_bandages":false,
                        "superficial_dressing":false
                    },
                    "low": {
                        "risk_of_morbidity":false,
                        "minor_surgery":false,
                        "physical_therapy":false,
                        "occupational_therapy":false,
                        "iv_fluids":false
                    },
                    "moderate": {
                        "risk_of_morbidity":false,
                        "prescription_drug_management":false,
                        "decision_minor_surgery":false,
                        "decision_major_surgery":false,
                        "diagnosis_limited_social":false
                    },
                    "high": {
                        "risk_of_morbidity":false,
                        "drug_therapy_elective":false,
                        "decision_elective_major":false,
                        "decision_emergency_surgery":false,
                        "decision_hospitilalization":false,
                        "decision_dnr":false,
                        "controlled_substances":false
                    }
                },
                "time": 0,
                "cc_time":0,
                "cc_add":false,
                "nurse_only":false
            }
            this.showWorksheet = true;
        }else if (JSON.stringify(this.mdmVal.worksheet).includes("minimal")){
            let wsheetstring = JSON.stringify(this.mdmVal.worksheet),
                fixstring = wsheetstring.replace(/minimal/g,"straightforward");
            this.mdmVal.worksheet = JSON.parse(fixstring);
            this.showWorksheet = true;
        }else{
            this.showWorksheet = true;
        }
        this.getData(
            "https://vzw8xog2f7.execute-api.us-east-1.amazonaws.com/v2/worksheet/" + this.facility + "/clinic_23"
        ).then((response) => {
            this.worksheetsettings = response;
            this.clinicUp++;
            this.calculateCLINIC();
        });
        this.clinicUp++;
    },
    // beforeMount: function() {
    //     
    // },
    methods: {
        compObjs(a,b){
            let aa = Object.keys(a).sort().reduce((obj, key) => { obj[key] = a[key]; return obj;}, {}),
                bb = Object.keys(b).sort().reduce((obj, key) => { obj[key] = b[key]; return obj;}, {});

            return JSON.stringify(aa) != JSON.stringify(bb);
        },
        mdmChanged(){
            // console.log("MDM FORM CHANGE");
            this.calculateCLINIC();
        },
        calculateCLINIC(){
            if(!this.noCalc){
                // console.log("CALCULATING WORKSHEET");
                this.clinicTool.tool = "clinic23";
                let patientType = this.mdmVal.worksheet.general.patientType;

                let nurse_only = false;
                this.nurseOnly = false;
                if(this.pos && this.calcLogic23[this.pos]){
                    if(this.pos == "23"){
                        this.mdmVal.worksheet.time = 0;
                    }
                    if(this.calcLogic23[this.pos].any){
                        patientType = "any"
                    }
                    if(this.calcLogic23[this.pos][patientType] && this.calcLogic23[this.pos][patientType].nurse_only){
                        this.nurseOnly = true;
                        nurse_only = this.mdmVal.worksheet.nurse_only;
                    }
                }
                this.mdmVal.worksheet.nurse_only = nurse_only;
                this.clinicTool.nurse_only = nurse_only;
                // console.log("NURSE ONLY? " + nurse_only);

                let time = this.mdmVal.worksheet.time,
                cc_time = (this.mdmVal.worksheet.cc_time ? this.mdmVal.worksheet.cc_time : 0);
                this.clinicTool.patientType = patientType;
                this.clinicTool.time = time;
                // console.log("TIME: " + time);
                this.clinicTool.cc_time = cc_time;
                // console.log("CC TIME: " + cc_time);
                this.clinicTool.cc_add = (this.mdmVal.worksheet.cc_add ? this.mdmVal.worksheet.cc_add : false);

                

                let chartamin = Object.values(this.mdmVal.worksheet.charta.straightforward).includes(true),
                    chartalow = Object.values(this.mdmVal.worksheet.charta.low).includes(true),
                    chartamod = Object.values(this.mdmVal.worksheet.charta.moderate).includes(true),
                    chartahigh = Object.values(this.mdmVal.worksheet.charta.high).includes(true);
                this.clinicTool.charta = (chartahigh ? "High" : (chartamod ? "Moderate" : (chartalow ? "Low" : chartamin ? "Straightforward" : "")));
                
                const sumValues = obj => Object.values(obj).reduce((a, b) =>parseInt(a) + parseInt(b));
                let tablebconv = {"td_1-ihx_0-intpr_0-disc_0":"Straightforward","td_0-ihx_1-intpr_0-disc_0":"Limited","td_1-ihx_1-intpr_0-disc_0":"Limited","td_2-ihx_1-intpr_0-disc_0":"Moderate","td_1-ihx_0-intpr_1-disc_0":"Moderate","td_1-ihx_0-intpr_0-disc_1":"Moderate","td_2-ihx_0-intpr_1-disc_0":"Moderate","td_2-ihx_0-intpr_0-disc_1":"Moderate","td_3-ihx_0-intpr_0-disc_0":"Moderate","td_3-ihx_1-intpr_0-disc_0":"Moderate","td_0-ihx_0-intpr_1-disc_0":"Moderate","td_0-ihx_0-intpr_1-disc_0":"Moderate","td_2-ihx_1-intpr_1-disc_0":"High","td_2-ihx_1-intpr_0-disc_1":"High","td_3+-ihx_0-intpr_1-disc_0":"High","td_3+-ihx_0-intpr_0-disc_1":"High","td_3+-ihx_1-intpr_1-disc_0":"High","td_3+-ihx_1-intpr_0-disc_1":"High","td_0-ihx_0-intpr_1-disc_1":"High"};
                let chartbtdarr = [];

                Object.entries(this.mdmVal.worksheet.chartb.td).forEach(([key,value]) => chartbtdarr.push(value ? value : 0));

                let chartbtdval = sumValues(chartbtdarr),
                    // chartbtd = (chartbtdval > 3 ? "3+" : chartbtdval),
                    // chartbihx = (this.mdmVal.worksheet.chartb.ihx.individual_who_provides_history ? 1 : 0),
                    // chartbintpr = (this.mdmVal.worksheet.chartb.intpr.independent_interpretation_of_a_test ? 1 : 0),
                    // chartbdisc = (this.mdmVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int ? 1 : 0),
                    //chartblookup = "td_" + chartbtd + "-ihx_" + chartbihx + "-intpr_" + chartbintpr + "-disc_" + chartbdisc;
                    chartbtd = chartbtdval,
                    chartbihx = this.mdmVal.worksheet.chartb.ihx.individual_who_provides_history,
                    chartbintpr = this.mdmVal.worksheet.chartb.intpr.independent_interpretation_of_a_test,
                    chartbdisc = this.mdmVal.worksheet.chartb.disc.discussion_of_mgmt_testing_int,
                    chartbiidcount = (chartbihx ? 1 : 0) + (chartbintpr ? 1 : 0) + (chartbdisc ? 1 : 0);
                    
                //// console.log(chartblookup);
                // this.clinicTool.chartb = (tablebconv[chartblookup] ? tablebconv[chartblookup] : "Straightforward");

                // console.log("chartbtd: " + chartbtd + " | charbihx: " + chartbihx + " | chartbintpr: " + chartbintpr + " | chartbdisc: " + chartbdisc+ " | chartbiidcount: " + chartbiidcount);
                let chartbout = "Straightforward";
                if(chartbintpr && chartbdisc){
                    chartbout = "High";
                }else if(chartbtd>2 && (chartbintpr || chartbdisc)){
                    chartbout = "High";
                }else if(chartbtd>1 && chartbiidcount>1){
                    chartbout = "High";
                }else if(chartbintpr || chartbdisc){
                    chartbout = "Moderate";
                }else if(chartbtd>2){
                    chartbout = "Moderate";
                }else if(chartbtd>1 && chartbiidcount>0){
                    chartbout = "Moderate";
                }else if(chartbtd>0 && (chartbintpr || chartbdisc)){
                    chartbout = "Moderate";
                }else if(chartbihx){
                    chartbout = "Low";
                }else if(chartbtd>1){
                    chartbout = "Low";
                }

                this.clinicTool.chartb = chartbout;

                // let chartcmin = this.mdmVal.worksheet.chartc.straightforward,
                //     chartclow = this.mdmVal.worksheet.chartc.low,
                //     chartcmod = this.mdmVal.worksheet.chartc.moderate,
                //     chartchigh = this.mdmVal.worksheet.chartc.high;
                // this.clinicTool.chartc = (chartchigh ? "High" : (chartcmod ? "Moderate" : (chartclow ? "Low" : chartcmin ? "Straightforward" : "")));

                let chartcmin = Object.values(this.mdmVal.worksheet.chartc.straightforward).includes(true),
                    chartclow = Object.values(this.mdmVal.worksheet.chartc.low).includes(true),
                    chartcmod = Object.values(this.mdmVal.worksheet.chartc.moderate).includes(true),
                    chartchigh = Object.values(this.mdmVal.worksheet.chartc.high).includes(true);
                this.clinicTool.chartc = (chartchigh ? "High" : (chartcmod ? "Moderate" : (chartclow ? "Low" : chartcmin ? "Straightforward" : "")));
                
                // console.log("A: " + this.clinicTool.charta + " B: " + this.clinicTool.chartb + " C: " + this.clinicTool.chartc);

                this.$emit('worksheet-updated', this.clinicTool);
                //this.clinicUp++;
            }else{
                this.clinicTool.time = this.mdmVal.worksheet.time;
                // console.log("TIME: " + this.clinicTool.time);
                this.$emit('worksheet-updated', this.clinicTool);
                //this.clinicUp++;
            }
        },
        median(numbers) {
            const sorted = numbers.slice().sort((a, b) => a - b);
            const middle = Math.floor(sorted.length / 2);

            if (sorted.length % 2 === 0) {
                return (sorted[middle - 1] + sorted[middle]) / 2;
            }

            return sorted[middle];
        },
        modStringer(mods){
            let out = "";
            for(let m=0; m<mods.length; m++){
                out += mods[m] + (mods.length != m+1 ? ", " : "");
            }
            return out;
        },
        validateform(){
            this.validate();
        },
        reqCheck(field){
            let out = false;
            if(this.$store.getters.requiredFields.indexOf(field)>=0){
                out = true;
            }
            //// console.log("REQ CHECK: " + field + ": " + out);
            return out;
        },
        formatTime(inp){
            //// console.log(inp); // "([01]?[0-9]|2[0-3]):[0-5][0-9]"
            let out = "00:00";

            return inp;
        },
        dtConvert(dos,time,type,nd){
            //// console.log(dos + " | " + time + " | " + type + " | " + nd);
            let out = null,preout;
            if(type == "stop" && time && nd){
                let d = new Date(dos + " " + "12:00"),
                        dp = new Date(d.getTime() + 86400000),
                        dateplus = dp.toISOString().split("T")[0];
                // // console.log(d);
                // // console.log(dp);
                // // console.log(dateplus);
                preout = new Date(dateplus + " " + time);
                out = preout.getTime();
            }else if(time){
                preout = new Date(dos + " " + time);
                out = preout.getTime();
            }
            return out;
        },
        allCapArray(arr){
            //// console.log("IN: " + JSON.stringify(arr));
            for(let a=0; a<arr.length; a++){
                arr[a] = arr[a].toString().toUpperCase().replace(/\s+/g, '');
                let ind = arr.indexOf(arr[a]);
                //// console.log("IND: " + ind);
                //// console.log("A: " + a);
                if(ind != -1 && ind != a){
                    //arr.splice(a,1);
                    arr.splice(ind,1);
                }
            }
            let out = [...new Set(arr)]
            //// console.log("OUT: " + JSON.stringify(out));
            return out;
        },
        forceFormValidate(form){
            //// console.log("FORCE VALIDATE: " + form);
            this.$refs[form].validate();
        },
        getProviderDetail:function(uuid){
            if(uuid){
                let provDet = this.$store.getters.Providers.find(x => x.uuid == uuid),out="";
                // console.log(JSON.stringify(provDet));
                //// console.log(provDet.displayName + " (" + uuid + ")");
                if(provDet){
                    if(provDet.displayName){
                        out = provDet.displayName + " (" + uuid + ")"
                    }else{
                        out = uuid;
                    }
                }else{
                    out = uuid;
                }
                return out;
            }else{
                return "";
            }
        },
        async postData(url = "", data = {}) {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
                // Default options are marked with *
                const response = await fetch(url, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": jwt
                },
                //redirect: 'follow', // manual, *follow, error
                //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(data), // body data type must match "Content-Type" header
                });
                return response.json(); // parses JSON response into native JavaScript objects
        },
        async getData(url = "") {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
                    // Default options are marked with *
                    const response = await fetch(url, {
                    method: "GET", // *GET, POST, PUT, DELETE, etc.
                    mode: "cors", // no-cors, *cors, same-origin
                    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": jwt
                    },
                    //redirect: 'follow', // manual, *follow, error
                    //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                    });
                    return response.json(); // parses JSON response into native JavaScript objects
        },
        calcAge(){
            //// console.log("CALC AGE");
            this.menudob = false;
        },
        ageTator(dobin){
            //// console.log("DOB IN: " + dobin);
            let out;
            if(dobin && dobin.includes("/")){
                let dobarr = dobin.split("/"),
                    dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else if(dobin && dobin.includes("-")){
                let dobarr = dobin.split("-"),
                    dob = new Date(dobarr[0],dobarr[1],dobarr[2]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else{
                out = null;
            }
            return out
        }
    }
  };
</script>

<style>
    .nextDay label{
        font-size: 14px;
        line-height: 14px !important;
        margin-left: -5px;
    }
    .theme--dark.v-tabs-items{
        background-color: unset;
    }
    .checkBoxBorderedDK{
        border:thin solid rgba(255, 255, 255, 0.35);
    }

    .checkBoxBorderedLT{
        border:thin solid rgba(0, 0, 0, 0.35);
    }

    .tallField .v-input__slot{
        height: 50px !important;
    }

    .v-input__slot {
    align-items: center;
    justify-content: center;
    }
</style>